import { useRoutes } from "@hooks/useRoutes";
import { ComponentProps } from "@ts/components";
import { PageError, Sections } from "@ts/sanity";
import React, { FC } from "react";

export type ErrorInputProps = ComponentProps & {
  page: PageError;
};

export type ErrorOutputProps = {
  buttonLink: string;
  buttonText: string;
  paths: {
    title: string;
  }[];
  title: string;
  content?: Sections;
};

export const withError =
  (Component: FC<ErrorOutputProps>) =>
  ({ name = "Error", page, ...props }: ErrorInputProps): JSX.Element => {
    const { title, content } = page || {};
    const { linkResolver } = useRoutes();
    const link = linkResolver(page?.buttonLink);
    const { url: buttonLink, title: buttonText } = link || {};
    const paths = [{ title }];

    Component.displayName = name;
    return (
      <Component
        {...props}
        buttonLink={buttonLink}
        buttonText={buttonText}
        title={title}
        paths={paths}
        content={content}
      />
    );
  };
